import React, { useMemo, useState } from 'react';
import { FlagIcon } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { useJournal } from '../../context/JournalContext';

/** Days explicitly marked as pending review, independent from plan compliance. */
export function PendingReviewCard() {
  const {
    activeJournals
  } = useJournal();
  const [open, setOpen] = useState(false);
  const pending = useMemo(() => activeJournals.filter(journal => journal.reviewStatus === 'pending').sort((a, b) => b.date.localeCompare(a.date)), [activeJournals]);

  // Nothing pending, nothing rendered — no empty container or spacing.
  if (pending.length === 0) return null;
  return <div className="mt-3 rounded-2xl border p-4" style={{
    background: '#fff8dc',
    borderColor: '#e8c75a',
    borderWidth: 1,
    borderStyle: 'solid'
  }} data-id="element-270" data-mp="2cjwivjt05zz6">
      <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} className="flex w-full items-start justify-between gap-3 text-left" style={{
      color: '#8a6a00'
    }} data-id="element-271" data-mp="1jwk59z4tl2i0">
        <div data-id="element-272" data-mp="330k66vkb9lim">
          <p className="flex items-center gap-1.5 text-[12px] font-medium" data-id="element-273" data-mp="330ahrcewzmf1">
            <FlagIcon className="h-3.5 w-3.5" data-id="element-274" data-mp="37u67jrl0y2z4" />Pendientes de revisión
          </p>
          <p className="mt-1 text-xl font-semibold tabular-nums" data-id="element-275" data-mp="3cs7vapteaqgx">
            {pending.length} {pending.length === 1 ? 'día' : 'días'}
          </p>
        </div>
        <span className="text-[11px] font-medium underline underline-offset-2" data-id="element-276" data-mp="2k398vgi8p25t">
          {open ? 'Ocultar' : 'Ver lista'}
        </span>
      </button>

      {open && <ul className="mt-3 space-y-1 border-t pt-3" style={{
      borderColor: '#e8c75a'
    }} data-id="element-277" data-mp="2p12dw67t3q4i">
          {pending.map(journal => <li key={journal.date} className="text-[12.5px] capitalize" style={{
        color: '#8a6a00'
      }} data-id="element-278" data-mp="4c4v154m442m">
              {format(parseISO(journal.date), "EEEE d 'de' MMMM, yyyy", {
          locale: es
        })}
            </li>)}
        </ul>}
    </div>;
}